import React from 'react'
import { VisuallyHidden } from '@reach/visually-hidden'

const AccessibleContent = ({ accessibleLabel, children }) => {
  return (
    <>
      <VisuallyHidden data-testid="accessible-content">{accessibleLabel}</VisuallyHidden>
      <div aria-hidden="true" style={{ display: 'contents' }}>
        {/* "display: contents" allows the children to be rendered without an extra wrapper messing up layout or styling */}
        {children}
      </div>
    </>
  )
}

export default AccessibleContent
